import { render, staticRenderFns } from "./bsp-pdf-preview.vue?vue&type=template&id=6c6b78b3&scoped=true&"
import script from "./bsp-pdf-preview.vue?vue&type=script&lang=js&"
export * from "./bsp-pdf-preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6b78b3",
  null
  
)

export default component.exports